import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "@/routes/__root";

/**
 * Rol/grupo Cognito con acceso total. `admin` ve todo y puede entrar a
 * cualquier ruta protegida por rol.
 */
export const ADMIN_ROLE = "admin";

/** Grupos Cognito reconocidos por la app. Un usuario sin ninguno de estos no
 * tiene acceso a nada y debe caer en `/access-denied`. */
export const KNOWN_ROLES = ["admin", "inscripcion", "baja"] as const;

/** True si el usuario pertenece a al menos un grupo reconocido. */
export function hasAnyKnownRole(groups: readonly string[] | undefined): boolean {
  return (groups ?? []).some((g) => (KNOWN_ROLES as readonly string[]).includes(g));
}

/**
 * Devuelve un `beforeLoad` para proteger una ruta por rol (grupo Cognito).
 *
 * Permite el paso si el usuario pertenece al grupo `admin` o si alguno de sus
 * grupos coincide con `allowed`; en caso contrario redirige a `/access-denied`.
 *
 * Esto es gating de UX: la barrera de seguridad real vive en el autorizador
 * Lambda del gateway. El mapa rol→ruta aquí debe reflejar el del backend.
 */
export function requireRole(allowed: readonly string[]) {
  return ({ context }: { context: RouterContext }) => {
    const groups = context.auth.user?.groups ?? [];
    if (groups.includes(ADMIN_ROLE)) return;
    if (allowed.some((role) => groups.includes(role))) return;
    throw redirect({ to: "/access-denied" });
  };
}
